export default "__VITE_ASSET__CKaDT5k6__"